import { useState, useEffect } from 'react'
import {
  GUEST_ENGAGEMENT_HERO_TITLE,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export function useHeroTitleVisible(): {
  titleVariant: string | undefined
  isLoaded: boolean
  setIsLoaded: (loaded: boolean) => void
} {
  const [isLoaded, setIsLoaded] = useState(false)

  const decisionObj = useSpecificOptimizelyUserDecision(
    GUEST_ENGAGEMENT_HERO_TITLE,
    true,
  )

  const variantsMap = {
    [OPTIMIZELY_VARIANT_KEYS.HERO_TITLE_VISIBLE_VARIANT_A]: 'variant_a',
    [OPTIMIZELY_VARIANT_KEYS.HERO_TITLE_VISIBLE_VARIANT_B]: 'variant_b',
  }

  const heroTitleEnabled = [
    OPTIMIZELY_VARIANT_KEYS.HERO_TITLE_VISIBLE_VARIANT_A,
    OPTIMIZELY_VARIANT_KEYS.HERO_TITLE_VISIBLE_VARIANT_B,
  ].includes(decisionObj?.variationKey)

  // Update isLoaded state based on decisionObj availability
  useEffect(() => {
    if (decisionObj !== null) {
      setIsLoaded(true)
    } else {
      setTimeout(() => {
        setIsLoaded(true)
      }, 500)
    }
  }, [decisionObj])

  return {
    titleVariant: heroTitleEnabled
      ? variantsMap[decisionObj?.variationKey]
      : undefined,
    isLoaded,
    setIsLoaded,
  }
}
